import React from 'react';
import {Button} from 'components';
import {config} from 'helpers';
import {RootState} from 'store';
import {Announcement} from './announcement';
import css from './announcement.module.scss';

export class Update_2025_06_19 extends Announcement {
  eligible(state: RootState) {
    return !state.settings.announcements?.[this.constructor.name];
  }

  render() {
    return (
      <>
        <h1><b>Block Time</b></h1>
        <p>'Block Time' function allows you to reserve specific time slots for personal activities, helping you protect your schedule and maintain a better work-life balance. You can find this feature on the Today page in the main dropdown menu.</p>
        <p className={css.footer}>
          <Button onClick={this.props.decline}>
            {this.props.isLast ? 'close' : 'next'}
          </Button>
        </p>
      </>
    );
  }
}
